import { HOME_TYPE_OPTIONS } from '../../../lib/constants';
import { useFormContext } from 'react-hook-form';
import { useFormDataContext, useZipContext } from '../../../lib/contexts';
import { useRef } from 'react';
import CustomBackButton from '../../CustomComponents/CustomBackButton';
import { useScrollToTop } from '../../../lib/hooks';

function FormStep5({hideBackButton = false}) {
  const { register, setValue, trigger, handleSubmit, formState } =
    useFormContext();
  const { updateFormData, formData, updateStep } = useFormDataContext();
  const { errors } = formState;
  const home_typeRef = useRef();
  const {isAbTesting} = useZipContext();


  const handleClick = (event) => {
    event.stopPropagation();
    if (event.target.type !== 'radio') {
      const input = event.currentTarget.querySelector('input[type="radio"]');
      input.click();
    }
  };

  const handleClickContinue = handleSubmit(async (_data) => {
    const isValid = await trigger(['propertytype']);

    if (!isValid) {
      const [firstErrorKey] = Object.keys(errors);
      const errorRefs = {
        propertytype: home_typeRef,
      };

      errorRefs[firstErrorKey]?.current?.focus();
    } else {
      // Assuming updateStep increments the step by 1
      updateStep(formData.step + 1); // Update step on radio select
    }
  });
  const handleRadioChange = async (e) => {
    const selectedValue = e.target.value;

    setValue('propertytype', e.target.value);
    updateFormData({ propertytype: e.target.value });

    handleClickContinue();
  };

  useScrollToTop();

  return (
    <>
      <div id="question5">
        <h3 className="step-title">Confirm Your Home Type</h3>
        <ul className="radio-list">
          {HOME_TYPE_OPTIONS.map(
            ({ id, value, textOption, registerLabel }, index) => (
              <li
                key={`${id}-${index}`}
                className={`radio-list-item ${
                  errors[registerLabel] && 'form-step__error'
                }`}
                onClick={handleClick}
              >
                <input
                  type="radio"
                  value={value}
                  id={id}
                  ref={home_typeRef}
                  checked={formData.propertytype === value}
                  {...register(registerLabel, { required: true })}
                  onClick={handleRadioChange}
                />
                <label className="radio-button">
                  <span htmlFor={id}>{textOption}</span>
                  <div className="radiobutton"></div>
                </label>
              </li>
            )
          )}
        </ul>
      </div>
    </>
  );
}
export default FormStep5;
